function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React from "react";
import PropTypes from "prop-types";

var Tooltip = function (_React$Component) {
  _inherits(Tooltip, _React$Component);

  function Tooltip() {
    var _temp, _this, _ret;

    _classCallCheck(this, Tooltip);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      isActive: false
    }, _this.toggleTooltip = function () {
      _this.setState({
        isActive: !_this.state.isActive
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Tooltip.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.isActive !== this.props.isActive && !this.props.isActive) {
      this.setState({
        isActive: false
      });
    }
  };

  Tooltip.prototype.render = function render() {
    var isActive = this.state.isActive;
    return React.createElement(React.Fragment, null, React.createElement("button", {
      className: "button button--reset button--link",
      onClick: this.toggleTooltip
    }, React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "icon",
      style: {
        height: "1em",
        width: "1em"
      }
    }, React.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      transform: "translate(0 1)"
    }, React.createElement("path", {
      d: "M12.21875,0.6875 C8.56685645,0.682463399 5.19961248,2.57302485 3.42393058,5.62540966 C1.64824868,8.67779448 1.74372075,12.4113861 3.67329167,15.3770833 L0.71875,21.3125 L6.923,18.4855 C10.5513625,20.6441872 15.2093627,20.3755655 18.5403018,17.8155432 C21.871241,15.2555209 23.1486354,10.9624434 21.7261918,7.10837794 C20.3037483,3.25431251 16.4917043,0.67983776 12.21875,0.6875 Z"
    }), React.createElement("path", {
      d: "M14.375 14.4375L13.65625 14.4375C12.8623407 14.4375 12.21875 13.8218915 12.21875 13.0625L12.21875 9.625C12.21875 9.24530423 11.8969547 8.9375 11.5 8.9375L10.78125 8.9375M12.21875 5.84375C12.21875 5.65390212 12.0578523 5.5 11.859375 5.5"
    }), React.createElement("path", {
      d: "M11.859375,5.5 C11.6608977,5.5 11.5,5.65390212 11.5,5.84375 C11.5,6.03359788 11.6608977,6.1875 11.859375,6.1875 C12.0578523,6.1875 12.21875,6.03359788 12.21875,5.84375"
    })))), React.createElement("div", {
      className: "tooltip tooltip--hotspot " + (isActive && this.props.isActive ? "is-active" : null)
    }, React.createElement("div", {
      className: "tooltip__icon"
    }, React.createElement("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      className: "icon",
      style: {
        height: "1em",
        width: "1em"
      }
    }, React.createElement("g", {
      fill: "none",
      fillRule: "evenodd",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5",
      transform: "translate(0 1)"
    }, React.createElement("path", {
      d: "M12.21875,0.6875 C8.56685645,0.682463399 5.19961248,2.57302485 3.42393058,5.62540966 C1.64824868,8.67779448 1.74372075,12.4113861 3.67329167,15.3770833 L0.71875,21.3125 L6.923,18.4855 C10.5513625,20.6441872 15.2093627,20.3755655 18.5403018,17.8155432 C21.871241,15.2555209 23.1486354,10.9624434 21.7261918,7.10837794 C20.3037483,3.25431251 16.4917043,0.67983776 12.21875,0.6875 Z"
    }), React.createElement("path", {
      d: "M14.375 14.4375L13.65625 14.4375C12.8623407 14.4375 12.21875 13.8218915 12.21875 13.0625L12.21875 9.625C12.21875 9.24530423 11.8969547 8.9375 11.5 8.9375L10.78125 8.9375M12.21875 5.84375C12.21875 5.65390212 12.0578523 5.5 11.859375 5.5"
    }), React.createElement("path", {
      d: "M11.859375,5.5 C11.6608977,5.5 11.5,5.65390212 11.5,5.84375 C11.5,6.03359788 11.6608977,6.1875 11.859375,6.1875 C12.0578523,6.1875 12.21875,6.03359788 12.21875,5.84375"
    })))), React.createElement("div", {
      className: "tooltip__title"
    }, "Recording tips (desktop)"), React.createElement("div", {
      className: "tooltip__text"
    }, React.createElement("p", null, "Consider sitting down"), React.createElement("p", null, "Position the camera just above your eyeline, slightly pointed down"), React.createElement("p", null, "Check the light, look for soft, flattering light"), React.createElement("p", null, "Consider using mic for better audio"), React.createElement("p", null, "Avoid sounding flat on camera, shake it out and get loose")), React.createElement("div", {
      className: "tooltip__buttons"
    }, React.createElement("button", {
      className: "button button--size-s button--color-gigas button--style-default",
      onClick: this.toggleTooltip
    }, "got it"))));
  };

  return Tooltip;
}(React.Component);

Tooltip.propTypes = process.env.NODE_ENV !== "production" ? {
  isActive: PropTypes.bool
} : {};
export default Tooltip;